import { ApiResponse } from "../beta/apis/apiError";
import { convertToCamelCase } from "./convertToCamelCase";

export interface ValidationProblemDetails<T> {
  errors: [string, string][];
  type: string;
  title: string;
  status: number;
  traceId: string;
}

function isValidationProblemDetails<T>(
  response: ApiResponse
): response is ApiResponse & { body: ValidationProblemDetails<T> } {
  return response.body != null;
}

export function GetValidatedObject<T>(response: ApiResponse): T | undefined {
  if (isValidationProblemDetails(response)) {
    const errors = response.body.errors;
    const result: Partial<T> = {};
    for (const key in errors) {
      const errorMessages = errors[key];
      if (Array.isArray(errorMessages) && errorMessages.length > 0) {
        result[convertToCamelCase(key) as keyof T] = errorMessages[0];
      }
    }
    return result as T;
  }
  return undefined;
}
